// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".BillUnapplyVendorCreditDialog-body__WFynx{display:flex;flex-direction:column;gap:var(--size-4);padding:var(--size-4)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"body": "BillUnapplyVendorCreditDialog-body__WFynx"
};
export default ___CSS_LOADER_EXPORT___;
